(ns rothko.theme.manatee.editor.space
  (:require [garden.color :refer [rgb rgba]]
            [rothko.theme.manatee.editor.common :as common-theme]))

(def main
  (merge
   common-theme/different
   {:primary
    {:background-color :white}

    :edited
    {:color (rgb 120 0 0)
     :text-decoration :line-through}

    :ignored
    {:color (rgb 169 169 169)
     :background-color (rgba 211 211 211 0.4)}

    :as-edit
    {:color (rgb 60 179 113)
     :text-decoration :underline}

    :system-annotation
    {:background-color (rgb 255 255 210)}

    :suspicious
    {:background-color (rgb 255 238 238)}}))
